module.exports = {
  getUserStatsSummary: function (userId) {
    return this.getUserStats(userId, { include_summary_stats: true })
  },
  getUserStats: function (userId, params) {
    return this.client.get(`/v${this.v}/user_stats/${userId}/${this._stringify(params)}`)
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/userStats.js